import DataSource from '@glittr/frontend-core/src/core/v2/data/data-source';
import Vue from 'vue';
import PostFeedbackRequestModel from '../../../../../../services/v2/model/post-feedback-request-model';
import createFeedbackVueSchema from './create.vue.schema';
import LookupRequestModel from '../../../../../../services/v2/model/lookup-request-model';
import GetFeedbackByCompanyIdRequestModel from '../../../../../../services/v2/model/get-feedback-by-company-id-request-model';
import EventPageBase from '../../../../_base/EventPageBase';
import GuidEventLookupModel from '../../../../../../services/v2/model/guid-event-lookup-model';

export default class CreatePage extends EventPageBase {
  public get companyFeedbacksList() {
    if (this.createFeedbackDataSource.data !== undefined && this.createFeedbackDataSource.data.items !== undefined) {
      return this.createFeedbackDataSource.data?.items?.map((record) => ({
        id: record.data.id,
        companyId: record.data.companyId,
        eventRating: Vue.$tEnum('page.dashboard.companies.feedbacks.enum.eventRating', record.data.eventRating!),
        reparticipationRating: Vue.$tEnum('page.dashboard.companies.feedbacks.enum.reparticipationRating', record.data.reparticipationRating!),
        youthVisitorsCount: record.data.youthVisitorsCount,
        adultVisitorsCount: record.data.adultVisitorsCount,
        remark: record.data.remark,
      }));
    }
    return [];
  }

  public set companyFeedbacksList(value) { /* Do nothing */ }

  public createFeedbackModel: PostFeedbackRequestModel = new PostFeedbackRequestModel();

  public error?: Error | string = undefined;

  public isLoading = false;

  public isLoadingButton = false;

  public eventItems: GuidEventLookupModel[] | undefined;

  public isFeedbackEnabled: boolean | undefined = undefined;

  public get companyId() { return this.companiesDataSource.data?.data.id; }

  public createFeedbackDataSource = new DataSource({
    selectCommand: () => {
      const request = new GetFeedbackByCompanyIdRequestModel();
      request.companyId = this.companyId;
      request.eventIdentifier = this.eventsDataSource.filter.eventIdentifier;
      return Vue.$service.v2.api.tdg_Feedbacks.getFeedbackByCompanyId(request);
    },
    insertCommand: () => {
      const req = new PostFeedbackRequestModel();
      req.eventIdentifier = this.eventsDataSource.filter.eventIdentifier;
      req.companyId = this.companyId;
      req.eventRating = this.createFeedbackModel.eventRating;
      req.reparticipationRating = this.createFeedbackModel.reparticipationRating;
      req.youthVisitorsCount = this.createFeedbackModel.youthVisitorsCount;
      req.adultVisitorsCount = this.createFeedbackModel.adultVisitorsCount;
      req.remark = this.createFeedbackModel.remark;
      return Vue.$service.v2.api.tdg_Feedbacks.postFeedback(req);
    },
  });

  public companiesDataSource = new DataSource({
    selectCommand: Vue.$service.v2.api.tdg_Companies.getCompanyForUser,
  });

  public eventsDataSource = new DataSource({
    selectCommand: () => {
      const req = new LookupRequestModel();
      return Vue.$service.v2.api.tdg_Events.eventLookup(req);
    },
  });

  async initialize(): Promise<void> {
    await this.eventsDataSource.select();
    await this.loadEventLookup();
    await this.loadCompanyDataSource();
    this.createFeedbackDataSource.filter.companyId = this.companyId;
    await this.createFeedbackDataSource.select();

    if (this.companyFeedbacksList && this.companyFeedbacksList.length > 0) {
      Vue.$router.push('/tourdegwaerb/company/feedbacks/edit');
      return;
    }
    this.isLoadingButton = false;
    this.isLoading = false;
  }

  async saveNewFeedback() {
    this.isLoadingButton = true;
    const valid = this.createFeedbackModel.validateWithSchema(createFeedbackVueSchema);
    if (valid) {
      if (!this.createFeedbackModel) {
        this.createFeedbackModel = new PostFeedbackRequestModel();
      }
      this.createFeedbackModel!.companyId = this.companyId;
      try {
        await this.createFeedbackDataSource.insert(this.createFeedbackModel!);
        this.isLoading = true;
        this.isLoadingButton = false;
        Vue.$router.push('/tourdegwaerb/company/dashboard');
      } catch (error: any) {
        Vue.$log.error(error);
        this.error = error;
      }
    }
    this.isLoading = false;
    this.isLoadingButton = false;
  }

  async loadEventLookup() {
    if (this.eventsDataSource.data) {
      const res = this.eventsDataSource.data;

      this.eventItems = res.items.map((i) => {
        const model = new GuidEventLookupModel();
        model.id = i.data.id;
        model.caption = i.data.caption;
        model.isFeedbackEnabled = i.data.isFeedbackEnabled;

        return model;
      });

      if (this.eventItems.length > 0) {
        const lastItem = this.eventItems[this.eventItems.length - 1];
        this.eventsDataSource.filter.eventIdentifier = lastItem.id;
        this.isFeedbackEnabled = lastItem.isFeedbackEnabled;
      }
    }
  }
}
